module.exports = __webpack_public_path__ + "static/1024px-Port_Willunga_Beach-ae0f6199e150e43dead33e2bef8899db.jpg";